module.exports = __webpack_public_path__ + "static/media/vimeo.48ae29bd.svg";